import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer } from '../../Reusable'

import FadeIn from 'react-fade-in';
 
const { useHistory } = require('react-router-dom')

interface Props {
  pro: any;
}
const UnpaidOrdersList: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const [total_paid, setTotalPaid] = React.useState(0)
  const [total_waiting, setTotalWaiting] = React.useState(0)
  const pro = props.pro
  const proId = pro.id
  const total_pops = pro.total_used_pops || 0

  const onFetch = async () => {
    // Paid orders
    try {
      let ref: any = Fire.store().collection('orders')
        .where('proId', '==', proId)
        .where('pro_was_paid', '==', true)
        .orderBy('createdAt', 'desc')
      const list = await Fire.list(ref)
      let amount = 0
      for (const item of list)
        amount += Tools.applyPopFee(item.total || 0, item.pop_fee || 0)
      setTotalPaid(amount)
    } catch (err) {
      setError("Impossible de charger les commandes")
      console.warn(err)
    }

    // Unpaid orders
    try {
      let ref: any = Fire.store().collection('orders')
        .where('proId', '==', proId)
        .where('pro_was_paid', '==', false)
        .orderBy('createdAt', 'desc')

      const list = await Fire.list(ref)
      let amount = 0
      for (const item of list) {
        amount += Tools.applyPopFee(item.total || 0, item.pop_fee || 0)
        
        const val = item.total || 0
        item.total_col = Tools.renderPrice(val)
        item.date_created_col = item.createdAt ? Fire.getDateFor(item.createdAt) : new Date()
        item.date_col = item.createdAt ? Time.moment(Fire.getDateFor(item.createdAt)).format('DD/MM/YYYY HH[h]mm') : '-'
     }
      setTotalWaiting(amount)
      return list
    } catch (err) {
      setError("Impossible de charger les commandes")
      console.warn(err)
    }
    return []
  }

  const sorting = (search: string, items: any[]) => {
    return items.filter((item) => Tools.matchesSearch(search, item.name))
  }

  return (
    <React.Fragment>

      <div className="row">
        <div className="info-box col-sm">
          <span className="info-box-icon bg-success"><i className="fa fa-coins"></i></span>

          <div className="info-box-content">
            <span className="info-box-text">Total reversé</span>
            <span className="info-box-number">{Tools.renderPrice(total_paid)}</span>
          </div>
        </div>
        <div className="info-box col-sm">
          <span className="info-box-icon bg-success"><i className="fa fa-coins"></i></span>

          <div className="info-box-content">
            <span className="info-box-text">Pops utilisés</span>
            <span className="info-box-number">{total_pops} (= {Tools.renderPrice(total_pops)})</span>
          </div>
        </div>
        <div className="info-box col-sm">
          <span className="info-box-icon bg-success"><i className="fa fa-mountain"></i></span>

          <div className="info-box-content">
            <span className="info-box-text">En attente de reversement</span>
            <span className="info-box-number">{Tools.renderPrice(total_waiting)}</span>
          </div>
        </div>
      </div>

      <ListContainer
        title={'Commandes en cours de traitement'}
        searchTitle={'Rechercher une commande...'}
        error={error}
        onFetch={onFetch}
        onSelect={() => void 0}
        sorting={sorting}
        renderColumns={({ refresh }) => ([
          { name: 'N° de commande', string: 'ref', sortable: true, accessor: 'ref'},
          { name: 'Total', string: 'total_col', sortable: true, accessor: 'total_col'},
          { name: 'Date', date: 'date_created_col', sortable: true, accessor: 'date_col' },
        ])}
        />
    </React.Fragment>
  );
}

export default UnpaidOrdersList